import React, { useEffect } from 'react';
import Calendar from 'react-calendar';
import { useTranslation } from 'react-i18next';

import { formatDateTh, formatDay} from '../../../utils/Date';
import './MemoCalendar.scss';
// import 'react-calendar/dist/Calendar.css';
// import './MemoCalendar.css';
// import style from './MemoCalendar.scss';

const MemoCalendar = (props) => {
  const { markedDate, isLoading } = props;
  const { t, i18n } = useTranslation();
  const onSelectDateHandler = (date) => {
    props.onSelectDate(date);
  };

  const onMonthChangeHandler = (activeStartDate, view) => {
    if (view === 'month') {
      props.onMonthChange(activeStartDate);
    }
  };

  // select today date by default
  useEffect(() => {
    props.onSelectDate(new Date());
  }, []);

  return (
    <Calendar
      locale={i18n.language}
      calendarType={'US'}
      // className={style.reactCalendar}
      // className={[style['react-calendar']]}
      className={isLoading ? 'react-calendar__month-view__days__loading' : ''}
      showNeighboringMonth={false}
      onChange={onSelectDateHandler}
      formatDay={(locale, date) => formatDay(date)}
      onActiveStartDateChange={({ activeStartDate, view }) => {
        onMonthChangeHandler(activeStartDate, view);
      }}
      defaultView={'month'}
      minDetail={'decade'} //The least detailed view that the user shall see.
      tileClassName={({ date, view }) => {
        // date will return every date visible on calendar and view will view type (eg. month)
        // Color the sunday 'red'
        if (date.getDay() === 0 && view === 'month') {
          return 'react-calendar__month-view__days__day--sunday';
        }
        // Dot under the date number if it has notes
        if (markedDate.length > 0 ? markedDate.includes(formatDateTh(date)) : null) {
          return 'react-calendar__month-view__days__day--marked';
        }
      }}
    />
  );
};

export default MemoCalendar;
